export const formatNameForPatientChartTitle = (firstName = '', lastName = '') => {
  if (!firstName || !lastName) {
    return ''
  }
  return `${firstName.charAt(0).toUpperCase()}. ${lastName.charAt(0).toUpperCase()}${lastName.slice(1)}`
}
